// extracted by mini-css-extract-plugin
export default {"container":"GlobalHeader_container__gCtit","buttonArea":"GlobalHeader_buttonArea__y2+N+","logo":"GlobalHeader_logo__wdntn"};